@import '../../../theme.scss';

verdocs-view {
  display: flex;
  overflow: hidden;
  min-height: 600px;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
  font-family: $verdocs-primary-font;
  background-color: #f5f5f5;

  div,
  canvas {
    box-sizing: border-box;
  }

  .document {
    flex: 1;
    width: 100%;
    height: 100%;
    display: flex;
    // padding: 15px; // Reduced padding for zoom container
    row-gap: 15px;
    min-height: 200px;
    max-width: 1200px;
    position: relative;
    overflow-y: scroll;
    align-items: center;
    box-sizing: border-box;
    flex-direction: column;
    padding-right: 15px;

    .inner {
      width: 100%;
      max-width: 1028px;
    }
  }

  .signed-document-container {
    width: 64%;
    margin: 0 auto;
    transition: all 0.3s ease;
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;

    &.zoom-normal {
      width: 64%;
    }

    &.zoom-zoom1 {
      width: 80%;
    }

    &.zoom-zoom2 {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .signed-document-container {
      width: 100%;

      &.zoom-normal,
      &.zoom-zoom1,
      &.zoom-zoom2 {
        width: 100%;
      }
    }

    // Hide toolbars on mobile
    .controls-toolbar {
      .center-controls {
        display: none;
      }

      .right-controls {
        .icon-button {
          &.minus,
          &.plus {
            display: none;
          }
        }
      }
    }
  }

  .loading-indicator {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: 10000;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.7);
    justify-content: center;
    align-items: center;
  }

  verdocs-ok-dialog .background-overlay {
    align-items: flex-start;
    padding-top: 100px;
  }
}

// Styled separately because this toolbar can be reparented
#verdocs-view-header {
  // Use .controls-toolbar styles here
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  padding: 0 12px 0 24px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: none;
  font-family: 'Inter', sans-serif;
  color: #424242;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;

  .left-controls {
    flex: 1;
    display: flex;
    align-items: center;

    .title {
      font-weight: 500;
      font-size: 16px;
      color: #242424;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .center-controls {
    flex: 1;
    display: none; // Hidden for now
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 14px;
  }

  .right-controls {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .icon-button {
      width: 32px;
      height: 32px;
      display: flex;
      color: #424242;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s;

      &:hover {
        background-color: #f5f5f5;
      }

      &.disabled {
        opacity: 0.3;
        pointer-events: none;
      }

      svg {
        display: block;
        width: 20px;
        height: 20px;
      }
    }
  }
}

@media print {
  #verdocs-view-header {
    display: none !important;
  }

  verdocs-view {
    min-height: auto;
    background-color: white;

    .document {
      overflow: visible;
      height: auto;
      display: block;
      padding: 0;
    }

    .signed-document-container {
      width: 100%;
      margin: 0;
    }
  }
}
